const de = {
  common: {
    loading: 'Laden...',
    error: 'Fehler',
    provider_type: 'Anbietertyp',
    provider_type_all: 'Alle Anbieter',
    provider_type_atlar: 'Atlar',
    provider_type_ebics: 'Ebics',
    provider_type_synthetic: 'Synthetisch',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    back: 'Zurück',
    search: 'Suchen',
    clear: 'Löschen',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    ok: 'OK',
    copied: 'Kopiert',
    copy_to_clipboard: 'In Zwischenablage kopieren',
    show_more: 'Mehr anzeigen',
    show_less: 'Weniger anzeigen',
    just_now: 'gerade eben',
    not_found: 'Nicht gefunden',
    no_results: 'Keine Ergebnisse gefunden',
    actions: 'Aktionen',
    details: 'Details',
    edit_details: 'Details bearbeiten',
    go_to_home: 'Zur Startseite',
    refresh: 'Aktualisieren',
    download: 'Herunterladen',
    sign_in: 'Anmelden',
    forbidden: 'Zugriff verweigert',
    forbidden_description:
      'Sie haben keine Berechtigung, diese Seite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.',
    conflict:
      'Die Daten wurden zwischenzeitlich geändert. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
    too_many_requests: 'Zu viele Anfragen',
    too_many_requests_description:
      'Sie haben in kurzer Zeit zu viele Anfragen gesendet, daher begrenzt der Server sie vorübergehend – das liegt nicht an Ihren Daten oder einem Fehler Ihrerseits. Rate-Limits werden nach kurzer Zeit zurückgesetzt: Bitte warten Sie einen Moment, aktualisieren Sie dann die Seite und versuchen Sie es erneut.',
  },

  nav: {
    overview: 'Übersicht',
    dashboard: 'Dashboard',
    entities: 'Entitäten',
    managers: 'Verwalter',
    organisations: 'Organisationen',
    property_owners: 'Eigentümer',
    condominiums: 'WEGs',
    rental_contracts: 'Mietverträge',
    deposits: 'Kautionen',
    operations: 'Betrieb',
    bulk_actions: 'Massenaktionen',
    unallocated_incoming_payments: 'Nicht zugeordnete Eingangszahlungen',
    unallocated_outgoing_payments: 'Nicht zugeordnete Ausgangszahlungen',
    manager_background_processes: 'Verwalter-Hintergrundprozesse',
    ebics: 'Ebics',
    unprovisioned_ebics_accounts: 'Nicht provisionierte Konten',
    banking: 'Banking',
    accounts: 'Konten',
    deposit_account_vibans: 'Kautionskonto-vIBANs',
    bank_account_viban_projections: 'Bankkonto-vIBANs',
    payment_files: 'Zahlungsdateien',
    bank_credit_transfers: 'Banküberweisungen',
    bank_direct_debits: 'Banklastschriften',
    bank_transactions: 'Banktransaktionen',
    intraday_bank_transactions: 'Intraday-Transaktionen',
    bank_account_statements: 'Kontoauszüge',
    deposit_guarantees: 'Kautionsbürgschaften',
    deposit_guarantee_applications: 'Bürgschaftsanträge',
    claims: 'Forderungen',
    integrations: 'Integrationen',
    vvrb_requests: 'VVRB-Anfragen',
    vvrb_events: 'VVRB-Ereignisse',
    everreal_events: 'EverReal-Ereignisse',
    impower_events: 'impower-Ereignisse',
    inactive_email_recipients: 'Inaktive E-Mail-Empfänger',
    administration: 'Verwaltung',
    roles: 'Rollen',
    users: 'Benutzer',
    feature_toggles: 'Feature-Toggles',
  },

  sidebar: {
    switch_to_light: 'Zum hellen Modus wechseln',
    switch_to_dark: 'Zum dunklen Modus wechseln',
    log_out: 'Abmelden',
    language: 'Sprache',
    account: 'Konto',
    no_pages_available: 'Keine Seiten verfügbar',
    no_pages_available_description:
      'Sie haben keine Berechtigung, auf Seiten zuzugreifen. Bitte wenden Sie sich an Ihren Administrator.',
  },

  dashboard: {
    title: 'Dashboard',
    error_loading: 'Dashboard konnte nicht geladen werden.',
    summary: 'Zusammenfassung',
    metric: {
      credit_transfers_failed_7d: 'Fehlgeschlagene Überweisungen (7 T)',
      credit_transfers_in_flight: 'Laufende Überweisungen',
      active_bank_accounts: 'Aktive Bankkonten',
      total_balance: 'Gesamtsaldo',
    },
    breakdown: {
      title: 'Nach Kontotyp',
      active_accounts_count: '{{count}} aktive Konten',
    },
  },

  account: {
    title: 'Konto',
    error_loading: 'Ihr Konto konnte nicht geladen werden.',
    personal_information: 'Persönliche Informationen',
    first_name: 'Vorname',
    last_name: 'Nachname',
    email: 'E-Mail',
    security: 'Sicherheit',
    passkey: {
      title: 'Passkey',
      no_passkey_description:
        'Richten Sie einen Passkey als zweiten Faktor bei der Anmeldung ein.',
      has_passkey_description:
        'Auf Ihrem Konto ist ein Passkey registriert. Sie können ihn jederzeit ersetzen.',
      set_up_cta: 'Passkey einrichten',
      replace_cta: 'Passkey ersetzen',
      success_set_up: 'Passkey erfolgreich eingerichtet.',
      success_replaced: 'Passkey erfolgreich ersetzt.',
      error_unsupported:
        'Ihr Browser unterstützt keine Passkeys. Bitte verwenden Sie einen aktuellen Browser.',
      error_cancelled: 'Die Passkey-Einrichtung wurde abgebrochen.',
      error_timeout:
        'Die Passkey-Einrichtung ist abgelaufen. Bitte erneut versuchen.',
      error_invalid_state:
        'Dieser Authenticator ist bereits registriert. Bitte einen anderen verwenden.',
      error_security:
        'Bei der Passkey-Einrichtung ist eine Sicherheitsprüfung fehlgeschlagen.',
      error_generic:
        'Der Passkey konnte nicht eingerichtet werden. Bitte erneut versuchen.',
    },
    mcp: {
      section: 'MCP',
      title: 'Backoffice-MCP-Server',
      description:
        'Die Backoffice-API steht MCP-Clients über Streamable HTTP mit einem persönlichen API-Token zur Verfügung. Die Tools sind auf die Berechtigungen deines Kontos beschränkt.',
      generate_cta: 'Token erzeugen',
      regenerate_cta: 'Neues Token erzeugen',
      token_once:
        'Dein neues Token — kopiere es jetzt, es wird nicht erneut angezeigt',
      command_label: 'Zu Claude Code hinzufügen',
      success_generated: 'Token erzeugt. Das vorherige ist jetzt ungültig.',
      error_generating:
        'Das Token konnte nicht erzeugt werden. Bitte versuche es erneut.',
    },
  },

  passkey_prompt: {
    title: 'Passkey einrichten',
    description:
      'Für Ihr Konto ist ein Passkey erforderlich, um fortzufahren. Richten Sie jetzt einen ein, um weiter auf das Backoffice zugreifen zu können.',
    set_up_cta: 'Passkey einrichten',
    back_to_login_cta: 'Zurück zur Anmeldung',
    success: 'Passkey erfolgreich eingerichtet.',
    error_unsupported:
      'Ihr Browser unterstützt keine Passkeys. Bitte verwenden Sie einen aktuellen Browser.',
    error_cancelled: 'Die Passkey-Einrichtung wurde abgebrochen.',
    error_timeout:
      'Die Passkey-Einrichtung ist abgelaufen. Bitte erneut versuchen.',
    error_invalid_state:
      'Dieser Authenticator ist bereits registriert. Bitte einen anderen verwenden.',
    error_security:
      'Bei der Passkey-Einrichtung ist eine Sicherheitsprüfung fehlgeschlagen.',
    error_generic:
      'Der Passkey konnte nicht eingerichtet werden. Bitte erneut versuchen.',
    error_session_not_promoted:
      'Der Passkey wurde eingerichtet, aber die Anmeldung ist fehlgeschlagen. Bitte erneut anmelden.',
  },

  passkey_challenge: {
    title: 'Passkey bestätigen',
    description:
      'Bestätigen Sie Ihre Identität, indem Sie die Passkey-Abfrage in Ihrem Browser freigeben.',
    verify_cta: 'Passkey bestätigen',
    back_to_login_cta: 'Zurück zur Anmeldung',
    success: 'Passkey bestätigt.',
    error_unsupported:
      'Ihr Browser unterstützt keine Passkeys. Bitte verwenden Sie einen aktuellen Browser.',
    error_cancelled: 'Die Passkey-Bestätigung wurde abgebrochen.',
    error_timeout:
      'Die Passkey-Bestätigung ist abgelaufen. Bitte erneut versuchen.',
    error_invalid_state:
      'Dieser Passkey kann derzeit nicht verwendet werden. Bitte einen anderen versuchen.',
    error_security:
      'Bei der Passkey-Bestätigung ist eine Sicherheitsprüfung fehlgeschlagen.',
    error_generic:
      'Der Passkey konnte nicht bestätigt werden. Bitte erneut versuchen.',
    error_session_not_promoted:
      'Der Passkey wurde bestätigt, aber die Anmeldung ist fehlgeschlagen. Bitte erneut anmelden.',
  },

  auth: {
    not_signed_in: 'Nicht angemeldet',
    please_sign_in: 'Bitte melden Sie sich an, um fortzufahren',
    session_expired: 'Sitzung abgelaufen',
    session_expired_description:
      'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    something_went_wrong: 'Etwas ist schiefgelaufen',
    invalid_credentials: 'Falsche E-Mail oder falsches Passwort',
    login_failed: 'Anmeldung fehlgeschlagen',
    sign_in_title: 'Bei Getmomo anmelden',
    sign_in_description:
      'Verwenden Sie Ihre Backoffice-Zugangsdaten, um fortzufahren.',
    logging_out: 'Abmeldung...',
  },

  validation: {
    required: 'Dieses Feld ist erforderlich',
    invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    invalid_url: 'Bitte geben Sie eine gültige URL ein',
    too_short: 'Dieser Wert ist zu kurz',
    too_long: 'Dieser Wert ist zu lang',
    invalid_number: 'Bitte geben Sie eine gültige Zahl ein',
    min_value: 'Der Wert muss mindestens {{min}} betragen',
    max_value: 'Der Wert darf höchstens {{max}} betragen',
    invalid_date: 'Bitte geben Sie ein gültiges Datum ein',
    invalid_iban: 'Bitte geben Sie eine gültige IBAN ein',
    invalid_bic: 'Bitte geben Sie eine gültige BIC ein',
    invalid_format: 'Ungültiges Format',
    must_be_positive: 'Der Wert muss positiv sein',
    must_be_integer: 'Der Wert muss eine ganze Zahl sein',
    password_mismatch: 'Passwörter stimmen nicht überein',
    server: {
      email_already_exists:
        'Es gibt bereits einen Benutzer mit dieser E-Mail-Adresse',
      no_free_bank_account_iban:
        'Derzeit ist keine IBAN verfügbar. Bitte versuchen Sie es später erneut.',
      bank_account_iban_taken:
        'Diese IBAN ist bereits vergeben. Bitte versuchen Sie es erneut.',
    },
  },

  not_found: {
    title: 'Seite nicht gefunden',
    description: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
  },

  accounts: {
    title: 'Konten',
    search_placeholder: 'z.B. IBAN, Kontoname',
    create_account: 'Konto erstellen',
    seed_load_failed:
      'Das Konto zum Vorausfüllen konnte nicht geladen werden. Schließen und erneut versuchen.',
    owner_belongs_to_other_manager:
      'Der Eigentümer gehört zu einem anderen Verwalter.',
    error_loading: 'Fehler beim Laden der Konten',
    no_accounts: 'Keine Konten gefunden',
    type: 'Typ',
    account_name: 'Kontoname',
    iban: 'IBAN',
    iban_from_pool_placeholder: 'Leer lassen für die nächste freie IBAN',
    bic: 'BIC',
    manager: 'Verwalter',
    bank: 'Bank',
    provider: 'Anbieter',
    status: 'Status',
    daily_closing_balance: 'Tagesendsaldo',
    created_at: 'Erstellt am',
    all_types: 'Alle Typen',
    type_cash: 'Bar',
    type_rent: 'Miete',
    type_condo_fee: 'WEG-Gebühr',
    type_condo_reserve: 'WEG-Rücklage',
    all_statuses: 'Alle Status',
    status_draft: 'Entwurf',
    status_active: 'Aktiv',
    status_closure_requested: 'Schließung beantragt',
    status_closed: 'Geschlossen',
    account_actions: 'Kontoaktionen',
    detail: {
      invalid: 'Ungültiges Konto.',
      not_found: 'Konto nicht gefunden. Es wurde möglicherweise gelöscht.',
      server_error:
        'Kontodetails konnten aufgrund eines Serverfehlers nicht geladen werden. Bitte versuchen Sie es erneut.',
      account: 'Konto',
      id: 'ID',
      property_owner: 'Eigentümer',
      condominium: 'WEG',
      external_fee_account_name: 'Externes Gebührenkonto Name',
      external_fee_account_iban: 'Externes Gebührenkonto IBAN',
      bank_external_reference: 'Bank-Externe Referenz',
      provider_type: 'Anbieter',
      effective_annual_interest_rate: 'Effektiver Jahreszins',
      default: 'Standard',
      is_default: 'Standard',
      not_default: 'Kein Standard',
      provider_account_url: 'Anbieter-Konto-URL',
      provider_account_id: 'Anbieter-Konto-ID',
      allocated_vibans: 'Zugewiesene VIBANs',
      alias_vibans: 'Alias-VIBANs',
      bank_transactions: 'Banktransaktionen',
      view_bank_transactions: 'Banktransaktionen für dieses Konto anzeigen',
      intraday_transactions: 'Intraday-Transaktionen',
      view_intraday_transactions:
        'Intraday-Transaktionen für dieses Konto anzeigen',
      credit_transfers: 'Banküberweisungen',
      view_credit_transfers: 'Banküberweisungen für dieses Konto anzeigen',
      bank_account_vibans: 'Bankkonto-VIBANs',
      view_bank_account_vibans: 'Bankkonto-VIBANs für dieses Konto anzeigen',
      dates: 'Daten',
      updated_at: 'Aktualisiert am',
      closed_at: 'Geschlossen am',
      delete_confirm:
        'Bankkonto "{{name}}" löschen? Nur DRAFT-Konten können gelöscht werden. Dies kann nicht rückgängig gemacht werden.',
      deleted: 'Bankkonto wurde gelöscht.',
      error_deleting: 'Fehler beim Löschen des Bankkontos',
      delete_account: 'Konto löschen',
      closed_alert_title: 'Konto ist geschlossen',
      closed_alert_message:
        'Dieses Konto wurde geschlossen und kann nicht mehr bearbeitet werden.',
      unpaid_interest_files: {
        generate: 'Dateien für offene Zinsen erstellen',
        generating: 'Dateien für offene Zinsen werden erstellt…',
        downloaded: 'Dateien für offene Zinsen heruntergeladen.',
        failed: 'Die Dateien für offene Zinsen konnten nicht erstellt werden.',
        forbidden:
          'Sie haben keine Berechtigung, Dateien für offene Zinsen zu erstellen.',
        no_unpaid_interest:
          'Für dieses Konto gibt es im Quartal der Schließung keine offenen Zinsen.',
        tenant_viban_not_found:
          'Der Mietvertrag {{rentalContractId}} hat keine vIBAN auf diesem Konto.',
        closure_request_not_found:
          'Für dieses Konto wurde kein Schließungsantrag gefunden.',
        unsupported_account:
          'Nur Kautionskonten von HCOB und TEN31 mit Status "Schließung beantragt" werden unterstützt. Laden Sie die Seite neu.',
        negative_unpaid_interest:
          'Die offenen Zinsen sind negativ. Wenden Sie sich an das Engineering.',
        settlement_mismatch:
          'Die offenen Zinsen stimmen nicht mit dem Ledger-Saldo überein. Wenden Sie sich an das Engineering.',
        unprocessable_ledger_data:
          'Die Ledger-Daten können nicht automatisch verarbeitet werden. Wenden Sie sich an das Engineering.',
        missing_data:
          'Für die Dateien fehlen Daten. Wenden Sie sich an das Engineering.',
      },
      closure_requested_confirm:
        'Die Aktualisierung des Kontostatus auf "Schließung beantragt" ist eine UNUMKEHRBARE Aktion. Sind Sie sicher?\n\nDies ist endgültig und kann nur über ein Support-Ticket rückgängig gemacht werden. Der Status "Schließung beantragt" zeigt an, dass unser Kunde die Schließung des Bankkontos beantragt hat.\n\nSobald der Status aktualisiert ist, werden auf zugehörigen virtuellen Konten keine weiteren Zinsen mehr berechnet.',
    },
  },

  organisations: {
    title: 'Organisationen',
    search_placeholder: 'z.B. InWest Immobilien',
    error_loading: 'Fehler beim Laden der Organisationen',
    no_organisations: 'Keine Organisationen gefunden',
    create_organisation: 'Organisation erstellen',
    creating: 'Wird erstellt',
    edit_organisation: 'Organisation bearbeiten',
    updating: 'Wird aktualisiert',
    create: {
      description: 'Eine neue Organisation hinzufügen.',
      success: 'Organisation erstellt',
      error: 'Organisation konnte nicht erstellt werden',
    },
    edit: {
      description:
        'Den Namen und die Kontogebühren (in Cent) der Organisation aktualisieren.',
      success: 'Organisation aktualisiert',
      error: 'Organisation konnte nicht aktualisiert werden',
    },
    fees: {
      title: 'Monatliche Kontogebühren (in Cent)',
      deposit: 'Kaution (Cent)',
      rent: 'Mietzins (Cent)',
      condominium_fee: 'Hausgeld (Cent)',
      condominium_reserve: 'Rücklagen (Cent)',
      invalid: 'Bitte einen ganzzahligen Betrag in Cent eingeben, z.B. 750',
    },
    columns: {
      name: 'Name',
      status: 'Status',
      managers: 'Verwalter',
      created_at: 'Erstellt am',
    },
    status: {
      active: 'Aktiv',
      closed: 'Geschlossen',
    },
    detail: {
      invalid: 'Ungültige Organisation.',
      loading: 'Organisation wird geladen...',
      not_found: 'Organisation nicht gefunden.',
      organisation: 'Organisation',
      organisation_actions: 'Aktionen für Organisation',
      id: 'ID',
      name: 'Name',
      status: 'Status',
      close_organisation: 'Organisation schließen',
      reactivate_organisation: 'Organisation reaktivieren',
      close_dialog: {
        title: 'Organisation schließen',
        description:
          '{{organisationName}} schließen? Die Verwalter können sich nicht mehr anmelden und weder API noch Integrationen nutzen. Buchhaltung, Kontoauszüge und Bankdaten laufen weiter. Die Organisation kann später reaktiviert werden.',
        confirm: 'Schließen',
        closing: 'Wird geschlossen…',
      },
      closed_success: 'Organisation geschlossen',
      closed_error: 'Organisation konnte nicht geschlossen werden',
      reactivated_success: 'Organisation reaktiviert',
      reactivated_error: 'Organisation konnte nicht reaktiviert werden',
      managers: 'Verwalter',
      view_managers: 'Verwalter dieser Organisation anzeigen ({{count}})',
      users: 'Benutzer',
      view_users: 'Benutzer anzeigen',
      merge_organisation: 'In Organisation zusammenführen',
      merge_dialog: {
        title: 'In Organisation zusammenführen',
        description:
          '{{organisationName}} mit allen Verwaltern und Nutzern in eine bestehende Organisation verschieben. Nutzer beider Organisationen erhalten Zugriff auf alle Verwalter der Organisation.',
        target_organisation: 'Zielorganisation',
        merge: 'Zusammenführen',
        merging: 'Wird zusammengeführt…',
      },
      merged_into_organisation:
        'Organisation wurde in die Zielorganisation zusammengeführt.',
      error_merging: 'Fehler beim Zusammenführen der Organisation',
    },
  },

  managers: {
    title: 'Verwalter',
    search_placeholder: 'z.B. Max Mustermann, max@...',
    create_manager: 'Verwalter erstellen',
    error_loading: 'Fehler beim Laden der Verwalter',
    no_managers: 'Keine Verwalter gefunden',
    detail: {
      invalid: 'Ungültiger Verwalter.',
      loading: 'Verwalter wird geladen...',
      not_found: 'Verwalter nicht gefunden.',
      manager_actions: 'Verwalteraktionen',
      login_as_manager: 'Als Verwalter anmelden',
      edit_primary_user: 'Primären Nutzer bearbeiten',
      reset_password: 'Passwort zurücksetzen',
      send_onboarding_email: 'Onboarding-E-Mail senden',
      delete_confirm:
        'Möchten Sie {{name}} löschen? Diese Aktion ist endgültig.',
      deleted: 'Verwalter wurde gelöscht.',
      error_deleting: 'Fehler beim Löschen des Verwalters',
      password_reset_sent:
        'E-Mail zum Zurücksetzen des Passworts wurde gesendet.',
      error_resetting_password: 'Fehler beim Zurücksetzen des Passworts',
      onboarding_email_sent: 'Onboarding-E-Mail wurde gesendet.',
      error_sending_onboarding: 'Fehler beim Senden der Onboarding-E-Mail',
      identity: 'Identität',
      id: 'ID',
      user_id: 'Benutzer-ID',
      type: 'Typ',
      display_name: 'Anzeigename',
      organisation: 'Organisation',
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'E-Mail',
      email_verified_at: 'E-Mail bestätigt am',
      first_login_at: 'Erster Login am',
      password_set: 'Passwort gesetzt',
      company: 'Unternehmen',
      company_name: 'Firmenname',
      tax_id: 'Steuernummer',
      sales_tax_id: 'USt-ID',
      company_founded_date: 'Gründungsdatum',
      framework_agreement_signed: 'Rahmenvertrag unterzeichnet',
      address: 'Adresse',
      street: 'Straße',
      postal_code: 'Postleitzahl',
      region: 'Region',
      country: 'Land',
      other: 'Sonstiges',
      phone: 'Telefon',
      gender: 'Geschlecht',
      date_of_birth: 'Geburtsdatum',
      created_at: 'Erstellt am',
      pending_legal_consents: 'Ausstehende rechtliche Zustimmungen',
      user_consents: 'Nutzerzustimmungen',
      all_consents_accepted: 'Alle Geschäftsbedingungen akzeptiert',
      consent_document: 'Dokument',
      consent_version: 'Version',
      consent_service: 'Service',
      consent_description: 'Beschreibung',
      service_type_GENERAL: 'Allgemein',
      service_type_DEPOSIT: 'Kaution',
      service_type_RENT: 'Miete',
      service_type_CONDOMINIUM: 'Eigentümergemeinschaft',
      service_type_PRICE_LIST: 'Preisliste',
    },
  },

  deposits: {
    title: 'Kautionen',
    search_placeholder: 'z.B. Mietername, Konto',
    error_loading: 'Fehler beim Laden der Kautionen',
    no_deposits: 'Keine Kautionen gefunden',
    manager: 'Verwalter',
    tenant_name: 'Mietername',
    deposit_guarantee_application: 'Bürgschaftsantrag',
    deposit: 'Kaution',
    guarantee_active: 'Bürgschaft aktiv',
    deleted: 'Gelöscht',
    deleted_filter: 'Löschstatus',
    deleted_filter_all: 'Alle',
    deleted_filter_deleted: 'Gelöscht',
    created_at: 'Erstellt am',
    detail: {
      invalid: 'Ungültige Kaution.',
      loading: 'Kaution wird geladen...',
      not_found: 'Kaution nicht gefunden.',
      deposit: 'Kaution',
      status_manager_app: 'Status (Verwalter-App)',
      status: 'Status',
      sub_status: 'Unterstatus',
      main: 'Allgemein',
      id: 'ID',
      rental_contract: 'Mietvertrag',
      manager: 'Verwalter',
      tenant_name: 'Mietername',
      deposit_type: 'Kautionstyp',
      deleted_at: 'Gelöscht am',
      address_property: 'Adresse & Objekt',
      postal_code: 'Postleitzahl',
      region: 'Region',
      property_type: 'Objekttyp',
      storey: 'Stockwerk',
      street_name: 'Straßenname',
      street_number: 'Hausnummer',
      tenant_phone_number: 'Telefon des Mieters',
      property_owner: 'Eigentümer',
      financial_dates: 'Finanzen & Daten',
      cold_rent: 'Kaltmiete',
      deposit_amount: 'Kaution',
      start_date: 'Startdatum',
      created_at: 'Erstellt am',
      deposit_released_at: 'Kaution freigegeben am',
      move_out_date: 'Auszugsdatum',
      other: 'Sonstiges',
      given_reference: 'Angegebene Referenz',
      notes: 'Notizen',
      restore: 'Kaution wiederherstellen',
      restore_confirm:
        'Diese gelöschte Kaution und ihren Mietvertrag wiederherstellen? Beide werden wieder aktiv.',
      restored: 'Kaution wiederhergestellt',
      error_restoring: 'Fehler beim Wiederherstellen der Kaution',
      sub_status_values: {
        released: 'Freigegeben',
        released_with_remaining: 'Freigegeben, Restbetrag {{amount}}',
        outgoing_transactions: 'Ausgehende Transaktionen vorhanden',
        rejected_by_tenant: 'Abgelehnt vom Mieter',
      },
    },
  },

  claims: {
    title: 'Forderungen',
    search_placeholder: 'z.B. Forderungs-ID, Verwalter',
    error_loading: 'Fehler beim Laden der Forderungen',
    no_claims: 'Keine Forderungen gefunden',
    deposit: 'Kaution',
    manager: 'Verwalter',
    deposit_guarantee_application: 'Bürgschaftsantrag',
    amount: 'Betrag',
    closed: 'Geschlossen',
    created: 'Erstellt',
    detail: {
      id: 'ID',
      rental_contract: 'Mietvertrag',
      manager: 'Verwalter',
      deposit_guarantee_application: 'Bürgschaftsantrag',
      amount: 'Betrag',
      bank_account_iban: 'Bankkonto-IBAN',
      bank_account_name: 'Bankkontoname',
      comment: 'Kommentar',
      closed: 'Geschlossen',
      created: 'Erstellt',
      close_claim: 'Forderung schließen',
      reopen_claim: 'Forderung wieder öffnen',
      delete_confirm:
        'Sind Sie sicher, dass Sie diese Forderung löschen möchten?',
      closed_success: 'Forderung geschlossen',
      reopened_success: 'Forderung wieder geöffnet',
      deleted_success: 'Forderung gelöscht',
    },
  },

  unallocated_incoming_payments: {
    iban: 'Konto-IBAN (optional)',
    error_deposit_account_not_found:
      'Für eine nicht zugeordnete Zahlung wurde kein Kautionskonto gefunden.',
  },

  unprovisioned_ebics_accounts: {
    iban: 'IBAN',
    name: 'Name',
    currency: 'Währung',
    servicer_bic: 'Servicer-BIC',
    created: 'Erstellt',
    provision: 'Konto provisionieren',
    search_placeholder: 'Nach IBAN, Name, BIC suchen…',
    provision_success: 'Konto provisioniert',
    redirect_create:
      'Für diese IBAN existiert noch kein momo-Bankkonto — legen Sie es an, um die Provisionierung abzuschließen.',
    ebics_account_not_found:
      'Dieses Konto existiert nicht mehr im ebics-service.',
    provision_failed: 'Konto konnte nicht provisioniert werden',
  },

  unallocated_outgoing_payments: {
    reason: 'Grund',
    reason_batched: 'Von der Bank gebündelt ({{count}} Zahlungen)',
    allocate: {
      title: 'Zahlung zuordnen',
      loading: 'Wird zugeordnet',
      virtual_account_iban: 'Virtuelle Konto-IBAN',
      success: 'Zahlung erfolgreich zugeordnet',
      error: 'Zuordnung fehlgeschlagen',
      already_allocated:
        'Diese Zahlung wurde bereits zugeordnet. Die Liste wurde aktualisiert.',
      batched:
        'Diese Zahlung kann nicht zugeordnet werden: Die Bank hat {{count}} Zahlungen zu einer Buchung gebündelt, und eine Zuordnung bucht immer den vollen Betrag auf ein Konto.',
      negative_title:
        'Virtuelles Konto wird negativ: Möchten Sie wirklich fortfahren?',
      negative_description:
        'Der Zahlungsbetrag übersteigt den aktuellen Kontostand des virtuellen Kontos. Dadurch entsteht ein negativer Saldo.',
      confirm_negative: 'Ja, ins Minus gehen',
      viban_metadata: {
        tenant_name: 'Mieter',
        given_reference: 'Angegebene Referenz',
        current_balance: 'Aktueller Saldo',
      },
    },
    detail: {
      allocate_payment: 'Zahlung zuordnen',
      transaction_id: 'Transaktions-ID',
      bank_account_id: 'Bankkonto-ID',
      provider_type: 'Anbietertyp',
      counterparty_bic: 'BIC des Empfängers',
      booking_date: 'Buchungsdatum',
      value_date: 'Valutadatum',
      reference: 'Referenz',
      mandate_reference: 'Mandatsreferenz',
      viban: 'VIBAN',
      end_to_end_id: 'End-to-End-ID',
      return_reason: 'Rückgabegrund',
      allocated: 'Zugeordnet',
      returned: 'Zurückgegeben',
      backfilled: 'Nachgefüllt',
    },
  },

  bank_credit_transfers: {
    title: 'Banküberweisungen',
    all_statuses: 'Alle Status',
    statuses: {
      CREATED: 'Erstellt',
      SUBMITTED_TO_PROVIDER: 'An Anbieter übermittelt',
      REJECTED: 'Abgelehnt',
      SENT: 'Gesendet',
      ACCEPTED: 'Akzeptiert',
      EXECUTED: 'Ausgeführt',
      FAILED: 'Fehlgeschlagen',
      RETURNED: 'Zurückgebucht',
      UNKNOWN: 'Unbekannt',
    },
    search_placeholder: 'z.B. Referenz, IBAN',
    no_transfers: 'Keine Banküberweisungen gefunden',
    error_loading: 'Fehler beim Laden der Banküberweisungen',
    id: 'ID',
    status: 'Status',
    counterparty_name: 'Empfängername',
    counterparty_iban: 'Empfänger-IBAN',
    amount: 'Betrag',
    remittance: 'Verwendungszweck',
    manager_id: 'Verwalter-ID',
    deposit: 'Kaution',
    created: 'Erstellt',
    date: 'Datum',
    requested_execution_date: 'Ausführungsdatum',
    detail: {
      title: 'Banküberweisung {{id}}',
      invalid:
        'Ungültige Überweisung. Bitte wählen Sie eine Überweisung aus der Liste.',
      loading: 'Laden...',
      not_found:
        'Überweisung nicht gefunden. Sie wurde möglicherweise gelöscht.',
      details: 'Details',
      id: 'ID',
      status: 'Status',
      status_reason_code: 'Statusgrundcode',
      counterparty_name: 'Empfängername',
      counterparty_iban: 'Empfänger-IBAN',
      amount: 'Betrag',
      remittance_information: 'Verwendungszweck',
      manager: 'Verwalter',
      deposit_id: 'Kautions-ID',
      bank_account_id: 'Bankkonto-ID',
      idempotency_key: 'Idempotenzschlüssel',
      external_id: 'Externe ID',
      external_type: 'Externer Typ',
      batch_id: 'Batch-ID',
      is_backfilled: 'Nachgefüllt',
      external: 'Extern',
      open: 'Öffnen',
      dates: 'Daten',
      created_at: 'Erstellt am',
      updated_at: 'Aktualisiert am',
      submitted_to_provider_at: 'An Anbieter übermittelt am',
      rejected_at: 'Abgelehnt am',
      sent_at: 'Gesendet am',
      accepted_at: 'Akzeptiert am',
      executed_at: 'Ausgeführt am',
      failed_at: 'Fehlgeschlagen am',
      returned_at: 'Zurückgesendet am',
      requested_execution_date: 'Angefordertes Ausführungsdatum',
    },
  },

  bank_direct_debits: {
    title: 'Banklastschriften',
    all_statuses: 'Alle Status',
    statuses: {
      CREATED: 'Erstellt',
      SUBMITTED_TO_PROVIDER: 'An Anbieter übermittelt',
      REJECTED: 'Abgelehnt',
      SENT: 'Gesendet',
      ACCEPTED: 'Akzeptiert',
      EXECUTED: 'Ausgeführt',
      FAILED: 'Fehlgeschlagen',
      RETURNED: 'Zurückgebucht',
      UNKNOWN: 'Unbekannt',
    },
    search_placeholder: 'z. B. Mandat, Referenz, Manager-ID',
    no_transfers: 'Keine Banklastschriften gefunden',
    error_loading: 'Fehler beim Laden der Banklastschriften',
    id: 'ID',
    status: 'Status',
    counterparty_name: 'Zahlungspflichtiger',
    counterparty_iban: 'IBAN des Zahlungspflichtigen',
    amount: 'Betrag',
    mandate_id: 'Mandatsreferenz',
    sequence_type: 'Sequenz',
    manager_id: 'Manager-ID',
    requested_collection_date: 'Einzugsdatum',
    detail: {
      title: 'Banklastschrift {{id}}',
      invalid:
        'Ungültige Lastschrift. Bitte eine Lastschrift aus der Liste wählen.',
      loading: 'Lädt...',
      not_found:
        'Lastschrift nicht gefunden. Sie wurde möglicherweise gelöscht.',
      details: 'Details',
      id: 'ID',
      status: 'Status',
      status_reason_code: 'Statusgrund',
      status_reason_code_message: 'Statusgrundnachricht',
      counterparty_name: 'Zahlungspflichtiger',
      counterparty_iban: 'IBAN des Zahlungspflichtigen',
      amount: 'Betrag',
      remittance_information: 'Verwendungszweck',
      manager: 'Manager',
      deposit_id: 'Referenz-ID',
      bank_account_id: 'Bankkonto-ID',
      idempotency_key: 'Idempotenzschlüssel',
      external_id: 'Externe ID',
      external_type: 'Externer Typ',
      batch_id: 'Batch-ID',
      mandate: 'Mandat',
      mandate_id: 'Mandatsreferenz',
      mandate_signature_date: 'Mandatsunterschrift am',
      sequence_type: 'Sequenztyp',
      creditor_scheme_id: 'Gläubiger-ID',
      dates: 'Daten',
      created_at: 'Erstellt am',
      updated_at: 'Aktualisiert am',
      submitted_to_provider_at: 'An Provider übermittelt am',
      rejected_at: 'Abgelehnt am',
      sent_at: 'Gesendet am',
      accepted_at: 'Akzeptiert am',
      executed_at: 'Ausgeführt am',
      failed_at: 'Fehlgeschlagen am',
      returned_at: 'Zurückgegeben am',
      requested_collection_date: 'Gewünschtes Einzugsdatum',
    },
  },

  bank_account_statements: {
    title: 'Kontoauszüge',
    search_placeholder: 'z.B. IBAN, Referenz-ID, Verwalter-ID, Objektschlüssel',
    no_statements: 'Keine Kontoauszüge gefunden',
    error_loading: 'Fehler beim Laden der Kontoauszüge',
    download: 'Kontoauszug herunterladen',
    regenerate: 'Kontoauszug neu erzeugen',
    regenerate_scheduled: 'Neuerzeugung des Kontoauszugs eingeplant',
    status: 'Status',
    status_description: 'Statusbeschreibung',
    status_all: 'Alle Status',
    status_draft: 'Entwurf',
    status_in_progress: 'In Bearbeitung',
    status_processed: 'Verarbeitet',
    status_failed: 'Fehlgeschlagen',
    reference_type: 'Referenztyp',
    reference_type_all: 'Alle Referenztypen',
    reference_type_bank_account: 'Bankkonto',
    reference_type_bank_account_viban: 'Bankkonto-vIBAN',
    reference_id: 'Referenz-ID',
    iban: 'IBAN',
    value_date: 'Wertstellungsdatum',
    downloaded_at: 'Heruntergeladen am',
    bucket_name: 'Bucket-Name',
    object_key: 'Objektschlüssel',
    detail: {
      actions: 'Kontoauszug-Aktionen',
      invalid:
        'Ungültiger Kontoauszug. Bitte wählen Sie einen Kontoauszug aus der Liste.',
      details: 'Details',
      storage: 'Speicher',
      timestamps: 'Zeitstempel',
      id: 'ID',
      version: 'Version',
      manager_id: 'Verwalter-ID',
      created_at: 'Erstellt am',
      updated_at: 'Aktualisiert am',
    },
  },

  intraday_bank_transactions: {
    title: 'Intraday-Transaktionen',
    search_placeholder: 'z.B. Gegenpartei, IBAN, Verwendungszweck, Referenz',
    no_transactions: 'Aktuell keine Intraday-Transaktionen',
    error_loading: 'Fehler beim Laden der Intraday-Transaktionen',
    direction: 'Richtung',
    direction_all: 'Alle Richtungen',
    direction_incoming: 'Eingehend',
    direction_outgoing: 'Ausgehend',
    incoming: 'Eingehend',
    outgoing: 'Ausgehend',
    amount: 'Betrag',
    counterparty_name: 'Name der Gegenpartei',
    counterparty_iban: 'IBAN der Gegenpartei',
    account_iban: 'Konto-IBAN',
    booking_date: 'Buchungsdatum',
    captured_at: 'Erfasst um',
    remittance: 'Verwendungszweck',
    entry_reference: 'Eintragsreferenz',
    matched_payment: 'Zugeordnete Zahlung',
    matched_ct: 'Überweisung',
    matched_dd: 'Lastschrift',
  },
  bank_transactions: {
    title: 'Banktransaktionen',
    search_placeholder: 'z.B. Referenz, IBAN, vIBAN',
    no_transactions: 'Keine Banktransaktionen gefunden',
    error_loading: 'Fehler beim Laden der Banktransaktionen',
    id: 'ID',
    is_allocated: 'Ist zugeordnet',
    counterparty_name: 'Gegenpartei-Name',
    counterparty_iban: 'Gegenpartei-IBAN',
    amount: 'Betrag',
    remittance: 'Verwendungszweck',
    bank_account_id: 'Bankkonto-ID',
    viban: 'vIBAN',
    value_date: 'Wertstellungsdatum',
    booking_date: 'Buchungsdatum',
    create_bank_transaction: 'Banktransaktion erstellen',
    creating: 'Wird erstellt',
    create: {
      description:
        'Erstellen Sie manuell eine Banktransaktion auf einem bestehenden Bankkonto.',
      success: 'Banktransaktion wurde erstellt.',
      error: 'Fehler beim Erstellen der Banktransaktion',
      bank_account: 'Bankkonto',
      provider_account_id: 'Provider-Konto-ID',
      provider_entity_id: 'Provider-Entitäts-ID',
      amount_cents: 'Betrag (Cent)',
      counterparty_bic: 'Gegenpartei-BIC',
      reference: 'Referenz',
      mandate_reference: 'Mandatsreferenz',
      end_to_end_id: 'End-to-End-ID',
      return_reason: 'Rückgabegrund',
      is_returned: 'Ist zurückgegeben',
      is_backfilled: 'Ist nachgetragen',
      is_externally_initiated: 'Extern initiiert',
      is_allocated: 'Ist zugeordnet',
    },
    created: 'Erstellt',
    updated: 'Aktualisiert',
    detail: {
      title: 'Banktransaktion {{id}}',
      invalid:
        'Ungültige Transaktion. Bitte wählen Sie eine Transaktion aus der Liste.',
      loading: 'Laden...',
      not_found:
        'Transaktion nicht gefunden. Sie wurde möglicherweise gelöscht.',
      details: 'Details',
      provider: 'Anbieter',
      dates: 'Daten',
      id: 'ID',
      is_allocated: 'Ist zugeordnet',
      counterparty_name: 'Gegenpartei-Name',
      counterparty_iban: 'Gegenpartei-IBAN',
      counterparty_bic: 'Gegenpartei-BIC',
      amount: 'Betrag',
      remittance_information: 'Verwendungszweck',
      bank_account_id: 'Bankkonto-ID',
      viban: 'vIBAN',
      reference: 'Referenz',
      mandate_reference: 'Mandatsreferenz',
      end_to_end_id: 'End-to-End-ID',
      return_reason: 'Rückgabegrund',
      returned: 'Zurückgesendet',
      backfilled: 'Nacherfasst',
      externally_initiated: 'Extern initiiert',
      batch_transaction_count: 'Gebündelte Zahlungen',
      provider_type: 'Anbietertyp',
      provider_account_id: 'Anbieter-Konto-ID',
      provider_entity_id: 'Anbieter-Entitäts-ID',
      created_at: 'Erstellt am',
      updated_at: 'Aktualisiert am',
      value_date: 'Wertstellungsdatum',
      booking_date: 'Buchungsdatum',
    },
  },

  formance: {
    title: 'Formance-Transaktionen',
    none: 'Keine Formance-Transaktionen gefunden',
    error: 'Fehler beim Laden der Formance-Transaktionen',
    id: 'ID',
    amount: 'Betrag',
    source: 'Quelle',
    destination: 'Ziel',
    created_at: 'Erstellt am',
  },

  property_owners: {
    title: 'Eigentümer',
    search_placeholder: 'z.B. Max Müller',
    error_loading: 'Fehler beim Laden der Eigentümer',
    no_property_owners: 'Keine Eigentümer gefunden',
    type_individual: 'Privatperson',
    type_company: 'Unternehmen',
    create_property_owner: 'Eigentümer erstellen',
    create: {
      description: 'Einen Eigentümer für einen Verwalter erstellen.',
      success: 'Eigentümer erstellt',
      error: 'Eigentümer konnte nicht erstellt werden',
    },
    edit: {
      description: 'Eigentümerdaten aktualisieren.',
      success: 'Eigentümer aktualisiert',
      error: 'Eigentümer konnte nicht aktualisiert werden',
    },
    detail: {
      invalid: 'Ungültiger Eigentümer.',
      loading: 'Eigentümer wird geladen...',
      not_found: 'Eigentümer nicht gefunden.',
      identity: 'Identität',
      id: 'ID',
      type: 'Typ',
      company: 'Unternehmen',
      company_tax_id: 'Firmen-Steuernummer',
      phone: 'Telefon',
      email: 'E-Mail',
      manager: 'Verwalter',
      created: 'Erstellt',
      address: 'Adresse',
      street: 'Straße',
      postal_code: 'Postleitzahl',
      region: 'Region',
      country: 'Land',
      bank: 'Bank',
      customer_reference: 'Kundenreferenz',
      owner_1: 'Eigentümer 1',
      owner_2: 'Eigentümer 2',
      director: 'Geschäftsführer',
      first_name: 'Vorname',
      last_name: 'Nachname',
      date_of_birth: 'Geburtsdatum',
      tax_id: 'Steuernummer',
    },
  },

  roles: {
    title: 'Rollen',
    create_role: 'Rolle erstellen',
    search_placeholder: 'z.B. Admin',
    no_roles: 'Keine Rollen gefunden',
    error_loading: 'Fehler beim Laden der Rollen',
    role: 'Rolle',
    description: 'Beschreibung',
    users: 'Benutzer',
    permissions: 'Berechtigungen',
    project: 'Projekt',
    invalid_role: 'Ungültige Rolle. Bitte wählen Sie eine Rolle aus der Liste.',
    loading_role: 'Rolle wird geladen...',
    role_not_found: 'Rolle nicht gefunden. Sie wurde möglicherweise gelöscht.',
    role_information: 'Rolleninformationen',
    name: 'Name',
    manage_permissions: 'Berechtigungen verwalten',
    view_users_with_role: 'Benutzer mit dieser Rolle anzeigen',
    error_deleting_role: 'Fehler beim Löschen der Rolle',
    error_creating_role: 'Fehler beim Erstellen der Rolle',
    create_role_description:
      'Fügen Sie eine neue Rolle mit Name, Beschreibung und Projekttyp hinzu.',
    creating: 'Wird erstellt',
    role_updated: 'Rolle erfolgreich aktualisiert',
    error_updating_role: 'Fehler beim Aktualisieren der Rolle',
    edit_role: 'Rolle bearbeiten',
    edit_role_description:
      'Aktualisieren Sie die Rollenbeschreibung. Rollenname und Projekt können nicht geändert werden.',
    permissions_drawer: {
      title: 'Berechtigungen',
      description: 'Berechtigungen für diese Rolle umschalten',
      search_placeholder: 'z.B. deposit, create',
      no_permissions: 'Keine Berechtigungen gefunden',
      assigned: 'Zugewiesen',
      not_assigned_only: 'Nur nicht zugewiesene',
    },
    delete_dialog: {
      title: 'Rolle löschen',
      description:
        'Möchten Sie "{{roleName}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      deleting: 'Wird gelöscht...',
    },
  },

  users: {
    title: 'Benutzer',
    create_backoffice_user: 'Backoffice-Benutzer erstellen',
    search_placeholder: 'z.B. john@momo.de',
    no_users: 'Keine Benutzer gefunden',
    error_loading: 'Fehler beim Laden der Benutzer',
    all_roles: 'Alle Rollen',
    all_statuses: 'Alle Status',
    user: 'Benutzer',
    passkey: {
      title: 'Passkey',
      status_label: 'Status',
      status_registered: 'Registriert',
      status_not_registered: 'Nicht registriert',
      registered_on_label: 'Registriert am',
      reset_cta: 'Passkey zurücksetzen',
      reset_disabled_hint: 'Kein Passkey zum Zurücksetzen',
      reset_success: 'Passkey zurückgesetzt',
      reset_error: 'Passkey konnte nicht zurückgesetzt werden',
      reset_dialog: {
        title: 'Passkey für {{userName}} zurücksetzen?',
        description:
          'Der Passkey wird gelöscht. Der Benutzer muss bei der nächsten Anmeldung einen neuen Passkey registrieren.',
        confirm_cta: 'Zurücksetzen',
        resetting: 'Wird zurückgesetzt...',
      },
    },
    invalid_user:
      'Ungültiger Benutzer. Bitte wählen Sie einen Benutzer aus der Liste.',
    loading_user: 'Benutzer wird geladen...',
    user_not_found:
      'Benutzer nicht gefunden. Er wurde möglicherweise gelöscht.',
    user_information: 'Benutzerinformationen',
    full_name: 'Vollständiger Name',
    last_login: 'Letzter Login',
    joined: 'Beigetreten',
    organisation: 'Organisation',
    manage_roles: 'Rollen verwalten',
    backoffice_user_created: 'Backoffice-Benutzer erstellt',
    error_creating_backoffice_user:
      'Fehler beim Erstellen des Backoffice-Benutzers',
    create_backoffice_user_description:
      'Fügen Sie einen neuen Backoffice-Benutzer mit Zugangsdaten hinzu.',
    creating: 'Wird erstellt',
    first_name: 'Vorname',
    last_name: 'Nachname',
    password: 'Passwort',
    backoffice_user_updated: 'Backoffice-Benutzer aktualisiert',
    error_updating_backoffice_user:
      'Fehler beim Aktualisieren des Backoffice-Benutzers',
    edit_backoffice_user: 'Backoffice-Benutzer bearbeiten',
    edit_backoffice_user_description:
      'Aktualisieren Sie Name, E-Mail oder setzen Sie ein neues Passwort. Passwort leer lassen, um das aktuelle zu behalten.',
    user_updated: 'Benutzer aktualisiert',
    error_updating_user: 'Fehler beim Aktualisieren des Benutzers',
    edit_user: 'Benutzer bearbeiten',
    edit_user_description: 'Name oder E-Mail aktualisieren.',
    saving: 'Speichern',
    email_address: 'E-Mail-Adresse',
    password_hint: 'Passwort (mind. 12 Zeichen, leer lassen um beizubehalten)',
    roles_drawer: {
      title: 'Rollen',
      description: 'Rollen für diesen Benutzer umschalten',
      manager_description:
        'Ein Manager-Benutzer hat immer genau eine Rolle. Die gewählte Rolle ersetzt die aktuelle.',
      search_placeholder: 'z.B. Admin, Manager',
      no_roles: 'Keine Rollen gefunden',
      assigned: 'Zugewiesen',
    },
    delete_dialog: {
      title: 'Benutzer löschen',
      description:
        'Möchten Sie "{{userName}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      deleting: 'Wird gelöscht...',
    },
    error_deleting_user: 'Fehler beim Löschen des Benutzers',
    set_primary_user: {
      action: 'Zum primären Benutzer machen',
      title: 'Zum primären Benutzer machen',
      description:
        '{{userName}} zum primären Benutzer eines Verwalters der Organisation machen. Der bisherige primäre Benutzer des Verwalters wird ersetzt.',
      manager: 'Verwalter',
      select_manager: 'Verwalter auswählen…',
      search_manager: 'Verwalter suchen…',
      no_manager_found: 'Kein Verwalter gefunden.',
      confirm: 'Zum primären Benutzer machen',
      saving: 'Wird gespeichert…',
      success: 'Primärer Benutzer aktualisiert',
      error: 'Fehler beim Aktualisieren des primären Benutzers',
      error_not_admin:
        'Der Benutzer benötigt die Admin-Rolle, um primärer Benutzer zu werden',
    },
  },

  bulk_actions: {
    virtual_deposit_accounts: 'Virtuelle Kautionskonten',
    bulk_create_virtual_deposit_accounts:
      'Virtuelle Kautionskonten gesammelt erstellen',
    bulk_allocate_incoming_transfers:
      'Eingehende Überweisungen gesammelt zuordnen',
    bulk_close_virtual_deposit_accounts:
      'Virtuelle Kautionskonten gesammelt schließen',
    accounts: 'Konten',
    bulk_create_condominium_accounts: 'WEG-Konten gesammelt erstellen',
    bulk_create_rent_accounts: 'Mietkonten gesammelt erstellen',
    add_bank_account_ibans: 'IBANs zum IBAN-Pool der WEG-Konten hinzufügen',
    add_bank_account_ibans_with_free_count:
      'IBANs zum IBAN-Pool der WEG-Konten hinzufügen (frei: {{free}})',
    download_template: 'Vorlage',
    upload_success: 'Bulk-Import-CSV erfolgreich hochgeladen',
    upload_failed: 'Hochladen fehlgeschlagen',
    uploading: 'Wird hochgeladen...',
    upload_csv: 'CSV hochladen',
    validation_error: 'Validierungsfehler',
    csv_validation_description:
      'Wir haben Probleme in Ihrer CSV gefunden. Bitte laden Sie die Datei unten herunter, prüfen Sie die fehlerhaften Zeilen, korrigieren Sie sie und versuchen Sie es erneut.',
    download_import_results: 'Importergebnisse als CSV herunterladen',
    json_validation_file_prefix: 'Die Datei',
    json_validation_file_suffix: 'enthält ungültige Daten.',
    json_validation_description_prefix:
      'Validierungsfehler werden unten angezeigt. Pfade beginnen mit',
    json_validation_description_suffix:
      'Addieren Sie 2 zum Zeilenindex, um die CSV-Zeilennummer zu erhalten. Bitte korrigieren Sie die Fehler und versuchen Sie es erneut.',
  },

  rental_contracts: {
    title: 'Mietverträge',
    search_placeholder: 'z.B. Mietername, Adresse',
    error_loading: 'Fehler beim Laden der Mietverträge',
    no_rental_contracts: 'Keine Mietverträge gefunden',
    detail: {
      invalid: 'Ungültiger Mietvertrag.',
      loading: 'Mietvertrag wird geladen...',
      not_found: 'Mietvertrag nicht gefunden.',
      rental_contract: 'Mietvertrag',
      id: 'ID',
      deposit: 'Kaution',
      manager: 'Verwalter',
      tenant: 'Mieter',
      tenant_name: 'Name des Mieters',
      tenant_phone: 'Telefon des Mieters',
      source_id: 'Quell-ID',
      source_type: 'Quelltyp',
      deposit_account_viban: 'Kautionskonto-VIBAN',
      address: 'Adresse',
      postal_code: 'Postleitzahl',
      region: 'Region',
      property_type: 'Objekttyp',
      storey: 'Stockwerk',
      street_name: 'Straßenname',
      street_number: 'Hausnummer',
      property_owner: 'Eigentümer',
      property_owner_display_name: 'Anzeigename des Eigentümers',
      financial: 'Finanzen',
      cold_rent: 'Kaltmiete',
      deposit_amount: 'Kautionsbetrag',
      start_date: 'Startdatum',
      signed_date: 'Unterzeichnungsdatum',
      created: 'Erstellt',
      given_reference: 'Angegebene Referenz',
      notes: 'Notizen',
    },
    edit: {
      title: 'Mietvertrag bearbeiten',
      description:
        'Verwalter, Eigentümer und Herkunft aktualisieren. Andere Felder sind schreibgeschützt.',
      origin: 'Herkunft',
      success: 'Mietvertrag erfolgreich aktualisiert',
      error: 'Fehler beim Aktualisieren des Mietvertrags',
    },
  },

  bank_account_viban_projections: {
    allocated_at: 'Zugeordnet',
    kind: 'Art',
    alias: 'Alias',
    virtual_account: 'Virtuelles Konto',
    kind_all: 'Alle Arten',
    reference_type: 'Referenztyp',
    reference: 'Referenz',
    reference_type_property_owner: 'Eigentümer',
    detail: {
      version: 'Version',
      reference_type: 'Referenztyp',
      kind: 'Art',
      onboarding_external_reference: 'Externe Onboarding-Referenz',
      balance: 'Saldo',
      balance_updated_at: 'Saldo aktualisiert am',
    },
  },

  payment_files: {
    filename: 'Datei',
    status: 'Status',
    manager: 'Verwalter',
    type: 'Typ',
    submitted_at: 'Eingereicht',
    search_placeholder: 'Nach Verwalter oder IBAN suchen',
    all_statuses: 'Alle Status',
    download: 'Herunterladen',
    statuses: {
      UPLOAD_PENDING: 'Upload ausstehend',
      UPLOADED: 'Hochgeladen',
      VALIDATED: 'Validiert',
      INVALID: 'Ungültig',
      SUBMITTING: 'Wird eingereicht',
      SUBMITTED: 'Eingereicht',
      SUBMISSION_FAILED: 'Einreichung fehlgeschlagen',
      SENT: 'Gesendet',
      PROCESSED: 'Verarbeitet',
      FAILED: 'Fehlgeschlagen',
    },
    detail: {
      credit_transfers: 'Banküberweisungen',
      view_credit_transfers: 'Banküberweisungen für diese Datei anzeigen',
      direct_debits: 'Lastschriften',
      view_direct_debits: 'Lastschriften für diese Datei anzeigen',
      actions: 'Zahlungsdatei-Aktionen',
      details: 'Details',
      dates: 'Daten',
      id: 'ID',
      version: 'Version',
      updated_at: 'Aktualisiert',
      sender_iban: 'Absender-IBAN',
      bank_account_id: 'Bankkonto',
      transaction_count: 'Transaktionen',
      total_amount: 'Gesamtbetrag',
      external_entity_id: 'Provider-Referenz',
      validation_reason: 'Validierungsgrund',
      failure_reason: 'Fehlergrund',
      invalid: 'Ungültige Zahlungsdatei.',
      not_found: 'Zahlungsdatei nicht gefunden.',
    },
  },

  deposit_account_vibans: {
    detail: {
      viban: 'VIBAN',
      onboarding_external_reference: 'Onboarding-Externe Referenz',
      given_reference: 'Angegebene Referenz',
    },
    edit: {
      title: 'VIBAN bearbeiten',
      description:
        'Aktualisieren Sie die externe Onboarding-Referenz für diese VIBAN.',
      success: 'VIBAN erfolgreich aktualisiert',
      error: 'Fehler beim Aktualisieren der VIBAN',
    },
    upload: {
      button: 'VIBANs hochladen',
      success: 'VIBANs erfolgreich hochgeladen',
      error: 'Fehler beim Hochladen der VIBANs',
      total_vibans: 'Gesamtzahl VIBANs',
    },
  },

  manager_background_processes: {
    source: 'Ursprung',
    source_filter_all: 'Alle Ursprünge',
    source_filter_manager_app: 'Manager App',
    source_filter_public_api: 'Public API',
    detail: {
      id: 'ID',
      manager_id: 'Verwalter-ID',
      source: 'Ursprung',
      type: 'Typ',
      version: 'Version',
      total_items: 'Gesamtanzahl',
      completed_items: 'Abgeschlossen',
      bucket_name: 'Bucket-Name',
      artifact_filename: 'Artefakt-Dateiname',
      created: 'Erstellt',
      completed: 'Abgeschlossen',
      downloaded: 'Heruntergeladen',
      parameters: 'Parameter',
    },
  },

  deposit_guarantee_applications: {
    detail: {
      main: 'Allgemein',
      id: 'ID',
      provider: 'Anbieter',
      created_at: 'Erstellt am',
      deposit: 'Kaution',
      rental_contract: 'Mietvertrag',
      tenant_name: 'Name des Mieters',
      tenant_email: 'E-Mail des Mieters',
      tenant_phone: 'Telefon des Mieters',
      warm_rent: 'Warmmiete',
      tenant_iban: 'IBAN des Mieters',
      manager: 'Verwalter',
      property_owner: 'Eigentümer',
      mock_schufa_score: '[test] Schufa-Score auswählen',
      provider_fields: 'Anbieterfelder',
      fees_dates: 'Gebühren & Daten',
      monthly_fee: 'Monatliche Gebühr',
      yearly_fee: 'Jährliche Gebühr',
      start_date: 'Startdatum',
      accepted_at: 'Akzeptiert am',
      rejection: 'Ablehnung',
      rejected_at: 'Abgelehnt am',
      rejected_by: 'Abgelehnt von',
      reject_reason: 'Ablehnungsgrund',
      reject_comment: 'Ablehnungskommentar',
      contract_certificate: 'Vertrag / Zertifikat',
      swk_contract: 'SWK-Vertrag',
      review_swk_contract: 'SWK-Vertrag prüfen',
      vvrb_certificate: 'VVRB-Zertifikat',
      open_certificate: 'Zertifikat öffnen',
      upload_document: 'Dokument hochladen',
      income_proofs: 'Einkommensnachweise',
      residence_permits: 'Aufenthaltstitel',
      city_registrations: 'Meldebescheinigungen',
      rental_contract_documents: 'Mietvertragsdokumente',
      tenant_application: 'Mieterantrag',
      filename: 'Dateiname',
      url: 'URL',
    },
    edit: {
      title: 'Bürgschaftsantrag bearbeiten',
      description: 'Aktualisieren Sie die Mieter-IBAN für diesen Antrag.',
      success: 'Bürgschaftsantrag aktualisiert',
      error: 'Fehler beim Aktualisieren des Bürgschaftsantrags',
    },
  },

  condominiums: {
    title: 'WEGs',
    search_placeholder: 'z.B. Berliner Str. 12',
    create_condominium: 'WEG erstellen',
    error_loading: 'Fehler beim Laden der WEGs',
    no_condominiums: 'Keine WEGs gefunden',
    detail: {
      invalid: 'Ungültige WEG.',
      loading: 'WEG wird geladen...',
      not_found: 'WEG nicht gefunden.',
      title: 'Titel',
      legal_name: 'Rechtsname',
      address: 'Adresse',
      kyc: 'KYC',
      number_of_owners: 'Anzahl Wohnungseigentümer',
      tax_resident_outside_germany:
        'Die WEG ist außerhalb Deutschlands steuerlich ansässig',
      is_pep: 'Politisch exponierte Personen sind Teil der Geschäftsbeziehung',
      kyc_unanswered: 'Nicht angegeben',
    },
  },

  feature_toggles: {
    search_placeholder: 'z.B. ai_chat',
    error_loading: 'Fehler beim Laden der Feature-Toggles',
    error_updating: 'Fehler beim Aktualisieren des Feature-Toggles',
    no_rows: 'Keine Feature-Toggles gefunden',
    toggle: 'Umschalten',
    scope: 'Geltungsbereich',
    limited: 'Eingeschränkt',
    global: 'Global',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    managers: 'Verwalter',
    manager: 'Verwalter',
    scope_everyone: 'Alle',
    scope_selected: 'Ausgewählte Verwalter',
    add_manager: 'Hinzufügen',
    remove_manager: 'Verwalter entfernen',
    no_managers: 'Keine Verwalter ausgewählt, dieses Toggle gilt für niemanden',
    invalid: 'Ungültiges Feature-Toggle.',
    loading: 'Feature-Toggle wird geladen...',
    not_found: 'Feature-Toggle nicht gefunden.',
  },

  vvrb_requests: {
    search_placeholder: 'z.B. Request-ID',
    error_loading: 'Fehler beim Laden der VVRB-Anfragen',
    no_rows: 'Keine VVRB-Anfragen gefunden',
    invalid: 'Ungültige Anfrage.',
    loading: 'Anfrage wird geladen...',
    not_found: 'Anfrage nicht gefunden.',
    path: 'Pfad',
    process_id: 'VVRB-Prozess-ID',
    dga_id: 'DGA-ID',
    duration: 'Dauer',
    request: 'Anfrage',
    response: 'Antwort',
  },

  vvrb_events: {
    search_placeholder: 'z.B. Ereignistyp',
    error_loading: 'Fehler beim Laden der VVRB-Ereignisse',
    no_rows: 'Keine VVRB-Ereignisse gefunden',
    invalid: 'Ungültiges Ereignis.',
    loading: 'Ereignis wird geladen...',
    not_found: 'Ereignis nicht gefunden.',
    payload: 'Nutzlast',
  },

  everreal_events: {
    search_placeholder: 'z.B. Ereignistyp, ID',
    error_loading: 'Fehler beim Laden der EverReal-Ereignisse',
    no_rows: 'Keine EverReal-Ereignisse gefunden',
    invalid: 'Ungültiges Ereignis.',
    loading: 'Ereignis wird geladen...',
    not_found: 'Ereignis nicht gefunden.',
    payload: 'Nutzlast',
  },

  inactive_email_recipients: {
    search_placeholder: 'z.B. E-Mail-Adresse',
    error_loading: 'Fehler beim Laden der inaktiven E-Mail-Empfänger',
    no_rows: 'Keine inaktiven E-Mail-Empfänger gefunden',
    email: 'E-Mail',
    template: 'Vorlage',
    reason: 'Grund',
    last_failed_at: 'Zuletzt fehlgeschlagen',
    reactivate: 'Reaktivieren',
    reactivate_success: 'Empfänger reaktiviert',
    reactivate_failed: 'Empfänger konnte nicht reaktiviert werden',
  },

  impower_events: {
    search_placeholder: 'z.B. Ereignistyp, ID',
    error_loading: 'Fehler beim Laden der impower-Ereignisse',
    no_rows: 'Keine impower-Ereignisse gefunden',
    invalid: 'Ungültiges Ereignis.',
    loading: 'Ereignis wird geladen...',
    not_found: 'Ereignis nicht gefunden.',
    payload: 'Nutzlast',
    manager: 'Verwalter',
  },

  languages: {
    en: 'English',
    de: 'Deutsch',
  },
} as const;

export default de;
